import { Component, inject } from "@angular/core";
import { ExportBase } from "../export-base";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { IncidentService } from "@app/incident/services/incident.service";
import moment from "moment";
import { downloadWithLink } from "@methods/CommonMethods";
import { LocalizationService } from "@app/shared/localization/localization.service";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/export/i18n/scope";

@Component({
    selector: "export-incidents",
    templateUrl: "./export-incidents.component.html",
    styleUrl: "./export-incidents.component.scss",
    viewProviders: [provideTranslationScope(scope)],
    imports: [TranslatePipe]
})
export class ExportIncidentsComponent extends ExportBase {
    permService = inject(PermissionsService);

    private incidentService: IncidentService = inject(IncidentService);
    private readonly localizationService = inject(LocalizationService);
    public awaitingDownload: boolean = false;

    public download() {
        var dateTimeFormat = this.localizationService.getExportDateTimeFormat();
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.awaitingDownload = true;
        this.incidentService
            .exportIncidentsDetails(dateTimeFormat.dateFormat, dateTimeFormat.timeFormat, timeZone)
            .subscribe((data: Blob) => {
                const fileName = `Incidents_${moment().format("YYYYMMDDxHHmmss")}.xlsx`;
                const downloadURL = URL.createObjectURL(data);
                downloadWithLink(downloadURL, fileName);
                this.awaitingDownload = false;
            });
    }
}
